import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { colores } from '../../../styles/variablesCss';
import EncuestaFinalizar from '../../Checkout/EncuestaFinalizar';
import { trackPurchase } from '../../../utils/analytics';

const PagoOK = ({ navigation }) => {
  const [showSurvey, setShowSurvey] = useState(false);
  // Si se carga dentro de un iframe (respuesta del gateway), avisar al parent
  useEffect(() => {
    try {
      trackPurchase();
      if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'IPG_RESULT', status: 'ok' }, '*');
        // Limpia el contenido del iframe para que no muestre esta página
        setTimeout(() => {
          try { window.location.replace('about:blank'); } catch (e) {}
        }, 0);
      } else {
        // Solo mostrar encuesta cuando no estamos embebidos en iframe
        setShowSurvey(true);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  const goHome = () => {
    if (navigation && navigation.navigate) {
      navigation.navigate('Home');
    } else if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  };

  const handleSurveyClose = () => {
    setShowSurvey(false);
    goHome();
  };

  const handleSurveySubmit = () => {
    setShowSurvey(false);
    goHome();
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>¡Pago realizado con éxito!</Text>
      <Text style={styles.text}>Gracias por tu compra. En instantes te enviaremos la confirmación por email.</Text>
      {Platform.OS === 'web' ? (
        <a href="/" style={styles.buttonLink}>
          <Text style={styles.buttonText}>Volver al inicio</Text>
        </a>
      ) : (
        <TouchableOpacity style={styles.button} onPress={goHome}>
          <Text style={styles.buttonText}>Volver al inicio</Text>
        </TouchableOpacity>
      )}
      <EncuestaFinalizar
        visible={showSurvey}
        onClose={handleSurveyClose}
        onSubmit={handleSurveySubmit}
        onOpen={() => {}}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: colores.fondo,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colores.verde || '#2e7d32',
    marginBottom: 12,
    textAlign: 'center',
  },
  text: {
    fontSize: 16,
    color: colores.textoPrincipal,
    textAlign: 'center',
    marginBottom: 24,
  },
  button: {
    backgroundColor: colores.rojo,
    padding: 15,
    borderRadius: 8,
  },
  buttonLink: {
    display: 'inline-block',
    backgroundColor: colores.rojo,
    borderRadius: 8,
    padding: 15,
    cursor: 'pointer',
    // En React Native Web se usa textDecorationLine
    textDecorationLine: 'none',
  },
  buttonText: {
    color: colores.blanco,
    fontWeight: 'bold',
    fontSize: 16,
  },
});

export default PagoOK;
